import './TopNavbar.css'
import logo from '../../assets/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'
import {Link} from 'react-router-dom';
import { useContext } from 'react'
import RegisterContext from '../contexts/RegisterContext';

function TopNavbar() {
    // in order to show default page, user must be false
    // function to change this just in case user is true 
    // when button is clicked
    const {setUser,setShort,setNoMatch,setUnique} = useContext(RegisterContext);
    const setTrue = (e) => {
        setUser(false)
        setShort(false)
        setNoMatch(false)
        setUnique(false)
    }

    return (
        
        <div className="nav-container">
            <div className = "nav-tab-group-left">
                <div className = "nav-logo">
                    <img src={logo} className="nav-logo" alt="logo" title="logo"/>
                </div>
                {/* <button type="button" className="nav-tab">Home</button>
                <button type="button" className="nav-tab">Features</button>
                <button type="button" className="nav-tab">About Us</button> */}
            </div>
            <div className="nav-tab-group-right">
                <Link to="/" style={{textDecoration: 'none'}}>
                    <button type="button" className="nav-tab" onClick={setTrue}>Register</button>
                </Link>
                <Link to="/login" style={{textDecoration: 'none'}}>
                    <button type="button" className="nav-tab" onClick={setTrue} href="../../pages/Login">Sign In</button>
                </Link>
                {/* <FontAwesomeIcon icon={faBars} color="black" font-size="26"/> */}
            </div>
        </div>
    )
}

export default TopNavbar